/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import React from "react";
import ReactDOM from "react-dom/client";
import ContextProvider from "./context/ContextProvider";
import App from "./App"

import "bootstrap-icons/font/bootstrap-icons.css";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import "../src/assets/scss/style.scss";
import "../src/styles/style.css"
import "../src/styles/layer.css"
import "../src/styles/modal.css"
import "../src/styles/sidebar.css"
import "../src/styles/fonts.css"

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ContextProvider>
      <App />
    </ContextProvider>
  </React.StrictMode>
);
